(function () {
  function selectPlan(root, planEl) {
    if (!root || !planEl) return;

    var form = root.closest('form');
    var hidden = root.querySelector('[data-ee-selling-plan]');
    var priceEl = form ? form.querySelector('[data-ee-selling-plan-price]') : null;

    root.querySelectorAll('[data-ee-plan]').forEach(function (plan) {
      var isSelected = plan === planEl;
      plan.classList.toggle('is-selected', isSelected);
      var input = plan.querySelector('.ee-product-selling-plan__input');
      if (input) input.checked = isSelected;
    });

    if (hidden) hidden.value = planEl.getAttribute('data-selling-plan-id') || '';
    if (priceEl) {
      var formatted =
        planEl.getAttribute('data-atc-price-formatted') || planEl.getAttribute('data-price-formatted') || '';
      if (formatted) priceEl.textContent = formatted;
    }
  }

  function initRoot(root) {
    if (!root || root.getAttribute('data-ee-plans-bound') === 'true') return;
    root.setAttribute('data-ee-plans-bound', 'true');

    root.querySelectorAll('[data-ee-plan]').forEach(function (plan) {
      plan.addEventListener('click', function (event) {
        if (event.target.closest('[data-ee-switch-subscribe]')) return;
        selectPlan(root, plan);
      });

      var input = plan.querySelector('.ee-product-selling-plan__input');
      if (!input) return;
      input.addEventListener('change', function () {
        if (input.checked) selectPlan(root, plan);
      });
    });

    var switchBtn = root.querySelector('[data-ee-switch-subscribe]');
    if (switchBtn) {
      switchBtn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        var subscribe = root.querySelector('[data-ee-plan="subscribe"]');
        if (subscribe) selectPlan(root, subscribe);
      });
    }
  }

  function init(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-ee-selling-plans]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
